import humps from 'onyx-common/humps'

const decamelize = (param) => {
  return typeof param === 'string' ? humps.decamelize(param) : humps.decamelizeKeys(param)
}

export default decamelize
